import { Close } from '@mui/icons-material';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  IconButton,
} from '@mui/material';
import {
  GenButton,
  DropdownAutocomplete,
  GenCurrency,
} from '@pinnacleautomotive/clarity-components';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { getPrices } from '../../../redux/actions/orderDetailsActions';
import { selectPrices } from '../../../redux/selectors/ordersDetailsSelectors';

export default function AddServiceModal({
  data,
  open,
  onClose,
  loading,
  onAddService,
}) {
  const { t } = useTranslation(['orders', 'global']);
  const dispatch = useDispatch();
  const [selectedPrice, setSelectedPrice] = useState(null);
  const services = useSelector(selectPrices);

  useEffect(() => {
    if (!open) return;
    setSelectedPrice(null);
    dispatch(
      getPrices({
        vendor_id: data?.vendor?.companyId,
        departmentId: data?.dealer?.departmentId,
      })
    );
  }, [data, dispatch, open]);

  const onCloseHandle = () => {
    onClose();
  };

  const handleAddService = () => {
    onAddService({ ...selectedPrice });
  };

  return (
    <Dialog open={open} maxWidth="xs" fullWidth={true} onClose={onCloseHandle}>
      <DialogTitle sx={{ background: theme => theme.palette.grey[50] }}>
        <Box display="flex" flexDirection="row" alignItems="center">
          <Typography variant="subtitle2" flexGrow={1}>
            {t('addService.title')}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onCloseHandle}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" pt={3} justifyContent="space-between">
          <Box>
            <Typography variant="overline">{t('dealershipLabel')}</Typography>
            <Typography variant="body2">{data?.dealer.name}</Typography>
          </Box>
          <Box>
            <Typography variant="overline">{t('departmentLabel')}</Typography>
            <Typography variant="body2">{data?.dealer.department}</Typography>
          </Box>
        </Box>
        <Box pt={5} pb={15}>
          <DropdownAutocomplete
            renderAvatar={false}
            dropdownData={services.map(service => ({
              servicePriceId: service.servicePriceId,
              price: service.price,
              label: service.service.name,
            }))}
            handleOnChange={setSelectedPrice}
            renderOption={(props, option) => (
              <Typography>
                {option.label} (<GenCurrency value={option.price} />)
              </Typography>
            )}
            label="label"
            id="servicePriceId"
            multiSelect={false}
            value={selectedPrice}
            placeholder={t('addService.placeholder')}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="flex-end"
          alignItems="flex-end"
          gap={2}
          p={2}
        >
          <GenButton
            text={t('global:genericButtons.cancel')}
            order={0}
            disabled={loading}
            onClick={onCloseHandle}
            sx={{
              color: theme => theme.palette.text.primary,
              borderColor: theme => theme.palette.divider,
            }}
          />
          <GenButton
            text={t('addService.confirm')}
            order={1}
            color="primary"
            variant="contained"
            loading={loading}
            disabled={!selectedPrice}
            onClick={handleAddService}
          />
        </Box>
      </DialogActions>
    </Dialog>
  );
}
